import { TextEntry } from '@thg-commerce/gravity-theme'

export type LogoImageCollectionThemeInterface = {
  title: {
    font: {
      entry: TextEntry
    }
  }
}

export const LOGO_IMAGE_COLLECTION_THEME: LogoImageCollectionThemeInterface = {
  title: {
    font: {
      entry: 'large1',
    },
  },
}
